var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.24 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,0c5.72,2.47,11,5.37,11.23,13.3-1-.77-2.33-1.34-3-2.34-4.05-6.34-9.44-8.6-17.09-7-5.82,1.25-9.63,6-10,13.25a30.15,30.15,0,0,0,.91,9.85c2.51,8.81,14.24,12.45,21.64,7,4.1-3,4.54-6.79,1.71-10.44-2.78,2.23-5.35,4.83-8.42,6.52a6.2,6.2,0,0,1-5.64-.58c-1.8-1.52-4-4.34-3.7-6.26,1-6.94,7.13-6.1,12.39-6.53-1.73-8-8.56-.47-11.95-3.61C17.15,6.94,24.3,8.43,27,15.93c.41,1.15,1,2.59,2,3.14,7.37,4.18,6.51,15-2.4,19.21-1.18.55-2.35,1.14-3.53,1.72H13c-3.33-2.79-7.72-5-9.78-8.49C-3.87,19.38,1.21,5.43,14,0Zm.3,20.93c-3.45-.21-7.1-1.66-9.07,2.55-.28.61,1.54,3.06,2.66,3.29C21,27.59,23.21,25.65,23.31,20.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.76d81449d835fa7160dbe03d2755e5a4.svg";
export { ForwardRef as ReactComponent };